import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSacPlusFireCart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 302,
	height: 255,
	viewBox: "0 0 302 255",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M220.745 87.9615C224.144 86.894 227.831 87.2273 230.995 88.8883C234.16 90.5493 236.543 93.4021 237.622 96.8202L253.357 146.932L227.696 154.99L211.961 104.878C210.892 101.456 211.217 97.7533 212.864 94.5816C214.511 91.4099 217.345 89.0289 220.745 87.9615Z",
			fill: "#26CA99"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.13 145.628L182.981 169.02L205.725 161.878L188.13 145.628Z",
			fill: "#DE5727"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.957 53.6328C203.427 58.7813 195.11 61.1169 186.829 60.1284C178.547 59.1398 170.975 54.9076 165.771 48.3584L181.448 35.9666C182.364 37.199 183.517 38.236 184.839 39.0163C186.16 39.7966 187.623 40.3043 189.141 40.5093C190.659 40.7142 192.2 40.6123 193.674 40.2096C195.149 39.8068 196.525 39.1115 197.723 38.1646C198.921 37.2178 199.915 36.0388 200.647 34.6975C201.38 33.3561 201.835 31.8798 201.986 30.3558C202.137 28.8318 201.98 27.2911 201.526 25.8252C201.072 24.3592 200.329 22.9978 199.342 21.8214L215.018 9.42967C220.19 16.0027 222.562 24.3456 221.613 32.6309C220.665 40.9162 216.473 48.4682 209.957 53.6328Z",
			fill: "#DE5727"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M187.244 111.629L217.137 124.786C213.687 132.744 207.227 138.988 199.179 142.144C191.132 145.3 182.155 145.11 174.224 141.616C166.293 138.122 160.057 131.609 156.889 123.512C153.721 115.414 153.88 106.394 157.33 98.4362L187.244 111.629Z",
			fill: "#F1B820"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.354 85.2655L194.632 90.6735C193.775 87.2236 193.618 83.6364 194.171 80.1264C194.724 76.6165 195.975 73.2558 197.85 70.2453C199.724 67.2348 202.184 64.6364 205.081 62.6053C207.979 60.5742 211.254 59.1521 214.713 58.4242C218.171 57.6962 221.741 57.6773 225.209 58.3686C228.677 59.0598 231.972 60.4471 234.897 62.4473C237.821 64.4476 240.316 67.0198 242.232 70.0102C244.147 73.0006 245.444 76.3478 246.044 79.8516L220.354 85.2655Z",
			fill: "#F7DED9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.934 67.2462L155.936 83.4122L166.389 97.6273L183.835 95.689L190.833 79.523L180.389 65.3049L162.934 67.2462Z",
			fill: "#3032DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.508 184.061L154.548 184.183L154.598 184.3C155.383 186.146 156.825 187.638 158.647 188.479C160.467 189.32 162.535 189.451 164.447 188.843L278.934 152.894C280.975 152.253 282.672 150.824 283.656 148.926C284.64 147.028 284.829 144.818 284.19 142.781L272.649 106.027L271.735 103.118L268.827 104.032L259.295 107.025L256.386 107.938L257.3 110.846L266.422 139.898L166.79 171.182L143.433 100.278L143.393 100.157L143.343 100.04C142.559 98.1939 141.117 96.7027 139.295 95.8612L138.017 98.6288L139.295 95.8612C137.474 95.0206 135.406 94.8893 133.494 95.4976L96.7821 107.025L93.8737 107.938L94.7869 110.847L97.7978 120.436L98.7111 123.344L101.619 122.431L131.161 113.155L154.508 184.061Z",
			fill: "#3032DC",
			stroke: "#3032DC",
			strokeWidth: 6.09686
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.833 224.452C200.355 221.777 205.077 212.646 202.38 204.06C199.684 195.473 190.591 190.681 182.069 193.357C173.548 196.032 168.826 205.162 171.523 213.749C174.219 222.336 183.312 227.128 191.833 224.452Z",
			fill: "#3032DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M278.236 197.323C286.757 194.648 291.479 185.518 288.783 176.931C286.086 168.344 276.993 163.552 268.472 166.228C259.951 168.903 255.229 178.033 257.925 186.62C260.621 195.207 269.715 199.999 278.236 197.323Z",
			fill: "#3032DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4749 196.971C63.6765 178.986 74.1249 235.13 109.8 200.356C111.149 209.824 106.811 217.356 92.5154 221.418C123.113 229.709 138.117 212.112 141.028 195.009C142.787 186.395 142.978 174.632 138.117 166.626C126.628 147.704 105.772 151.454 91.3681 158.412C80.2024 163.805 71.6355 168.958 57.4755 162.775C57.4755 162.775 66.338 177.515 85.6019 175.939C72.7164 194.933 53.776 164.634 31.4749 196.971Z",
			fill: "#F1B820"
		})
	]
});
export default SvgSacPlusFireCart;
